import { getSession, clearSession } from '../../shared/auth/portalSession';
export const getAuthHeaders = (): HeadersInit => {
  const session = getSession('admin');
  return { 'Content-Type': 'application/json', ...(session ? { Authorization: `Bearer ${session.token}` } : {}) };
};
export const isAuthenticated = (): boolean => !!getSession('admin');
export const clearAuthData = (): void => clearSession('admin');
export const requireAuthentication = (): void => {
  if (!isAuthenticated()) {
    clearAuthData();
    throw new Error('Authentication required - please login again');
  }
};
